export default "__VITE_ASSET__ba7ea172__"